import { combineReducers } from 'redux';

import { App } from './App';
import { Auth } from './Auth';
import { Collections } from './Collections';
import { Files } from './Files';
import { Shares } from './Shares';
import { Metadata } from './Metadata';
import { Notifications } from './Notifications';
import { UploadPages } from './UploadPages';
import { Mini } from './Mini';
import { Search } from './Search';
import { People } from './People';

const rootReducer = combineReducers({
  App,
  Auth,
  Collections,
  Files,
  Shares,
  Metadata,
  Notifications,
  UploadPages,
  Mini,
  Search,
  People,
});

export default rootReducer;
